import { format } from 'date-fns';

function formatDateTimeString(dateString: string, formatting = 'dd MMM yy @ hh:mmbbb'): string {
  const date = new Date(dateString);

  return format(date, formatting);
}

export default formatDateTimeString;
